import {
  communityCardClickHandler,
  defaultSwiperOptions,
  getUnitType,
  googleMapMarkerIcon,
  googleMapStyles,
  isMobile,
  toggleEl,
} from '../../../js/modules/utilities';
import { getCommunityList } from '../../../js/api/community';
import { initQuickViewModal } from '../../../js/components/quick-view';

const maaCommunitiesSection = document.querySelector('section.maa-communities');
let currentFiltersBody = {};
const renderCommunityMap = () => {
  if (maaCommunitiesSection) {
    maaCommunitiesSection.classList.add('map-view');
    const locationId = maaCommunitiesSection.dataset.locationId;
    const templateId = maaCommunitiesSection.dataset.templateId;
    getCommunityList(locationId, templateId, currentFiltersBody)
      .then(async (response) => {
        initCommunityMap(response);
      });
  }

}

const initCommunityMap = async (data) => {

  const { Map } = await google.maps.importLibrary("maps");
  const icons = {
    point: {
      url: googleMapMarkerIcon.point,
      scaledSize: new google.maps.Size(40, 40)
    },
    activePoint: {
      url: googleMapMarkerIcon.activePoint,
      scaledSize: new google.maps.Size(40, 40)
    },
  }
  const mapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
    styles: googleMapStyles,
  };
  const markers = [];
  const map = new Map(maaCommunitiesSection.querySelector("#community-map"), mapOptions);
  const bounds = new google.maps.LatLngBounds();
  const infoWindows = [];

  data.communities.forEach((community) => {
    const marker = new google.maps.Marker({
      position: { lat: community.CommunityCoordinate.Lat, lng: community.CommunityCoordinate.Lon },
      map: map,
      icon: icons.point
    });
    let swiper;
    bounds.extend(marker.getPosition());
    let infoWindow;
    if (!isMobile) {
      const divItem = document.createElement('div');
      divItem.classList.add('item');
      divItem.innerHTML = `
        ${community.CommunityImages && community.CommunityImages.length ? `
          <div class="images-wrapper">
            <div id='swiper${-community.CommunityId}' class="community-list-swiper swiper-custom">
              <div class="swiper-wrapper">
                ${community.CommunityImages.map(image => {
                  return `
                    <div class="swiper-slide">
                      <img src='${image.Image.Src}' />
                    </div>
                    `;
                }).join('')}
              </div>
              <div class="swiper-pagination swiper-pagination-custom"></div>
            </div>
          </div>
          ` : ''
        }
          <div class="community-details" style="position: relative;">
            ${community.CommunityUnitTypes && community.CommunityUnitTypes.length ? `
              <a href="${community.CommunityPageUrl}" class="property-types link">
                ${community.CommunityUnitTypes.map(type => {
                  return `<span>${getUnitType(type)}</span>`;
                }).join('')}
              </a>
            ` : ''}
            <p class="price-range" style="position: absolute;right: 4px;top: -1px;font-size: 15px;">Rent starting at </p>
              <p class="price-range"><span style="position: absolute;right: 10px;bottom: -21px;">$${community.CommunityMinPrice} – $${community.CommunityMaxPrice}</span>
            </p>
          </div>
          <p class="community-neighborhood">
            ${community.CommunityNeighborhood}
          </p>
          <p class="community-name" style="margin-bottom: 10px;">
            ${community.CommunityName}
          </p>
      `;
      infoWindow = new google.maps.InfoWindow();
      divItem.addEventListener('click', communityCardClickHandler);
      infoWindow.setContent(divItem);
    }
    infoWindows.push(infoWindow);
    marker.addListener('click', () => {
      if (!isMobile) {
        infoWindows.forEach(el => el.close());
        infoWindow.open({
          anchor: marker,
          map,
        });
        infoWindow.addListener("domready", function() {
          if (swiper) {
            swiper.destroy();
          }
          swiper = initSlider(`#swiper${-community.CommunityId}`);
        });
      } else {
        markers.forEach((marker) => marker.setIcon(icons.point));
        marker.setIcon(icons.activePoint);
        const items = maaCommunitiesSection.querySelectorAll('.item');
        // communitiesList.classList.add('map-view-mobile');
        maaCommunitiesSection.classList.add('map-view-mobile');
        items.forEach((item) => {
          if (item.dataset.id === community.CommunityId) {
            item.classList.add('force-display')
          } else {
            item.classList.remove('force-display')
          }
        });
      }
    });
    markers.push(marker);
  });

  if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
    var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
    var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
    bounds.extend(extendPoint1);
    bounds.extend(extendPoint2);
 }

  map.fitBounds(bounds);
}
const destroyCommunityMap = () => {
  if (maaCommunitiesSection) {
    maaCommunitiesSection.classList.remove('map-view');
    maaCommunitiesSection.classList.remove('map-view-mobile');
    const map = maaCommunitiesSection.querySelector('#community-map')
    if (map) {
      map.innerHTML = '';
    }
  }
}

const initSlider = (selector) => {
  const swiperOptions = Object.assign({}, defaultSwiperOptions);
  return new Swiper(selector, swiperOptions);
}

const initListSliders = () => {
  initSlider('.community-list-swiper');
}

export const communityList = () => {
  if (maaCommunitiesSection) {
    const mapButton = maaCommunitiesSection.querySelector('#community-map-btn');
    if (mapButton) {
      mapButton.addEventListener('click', (e) => {
        e.stopPropagation();
        if (maaCommunitiesSection.classList.contains('map-view')) {
          destroyCommunityMap();
        } else {
          renderCommunityMap();
        }
      });
    }
    initListSliders();
    maaCommunitiesSection.querySelectorAll('.communities-list .item')
      .forEach((item) => {
        item.addEventListener('click', communityCardClickHandler);
      })
  }
}

export const toggleCommunitiesQuickActions = () => {

  // const copyAddress = (e) => {
  //   const address = e.currentTarget.dataset.value;
  //   e.stopPropagation();
  //   e.preventDefault();
  //   if (address) {
  //     copyTextToClipboard(address);
  //   }
  //   addToastMessage({
  //     body: 'Community address copied',
  //   });
  // }
  //
  // const addToCompareOptionClick = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   try {
  //     const item = e.currentTarget.closest('.item');
  //     const imagesWrapper = item.querySelector('.images-wrapper');
  //     const imgEl = imagesWrapper.querySelector('img');
  //     const nameEl = item.querySelector('.community-name');
  //     const imgSrc = imgEl.getAttribute('src');
  //     const nameText = nameEl.innerHTML;
  //     addToCompareHandler(e, imgSrc, nameText, 'right');
  //
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }
  //
  // const toggleEl = (event) => {
  //   const botao = event.currentTarget;
  //   const dropdown = botao.querySelector('.other-actions-dropdown-maa');
  //   if (dropdown) {
  //     dropdown.addEventListener('click', (e) => e.stopPropagation());
  //   }
  //   const parentDiv = botao.parentElement;
  //   const quickActionsEl = parentDiv.nextElementSibling;
  //   const item = event.currentTarget.closest('.item');
  //   const copyAddressOption = item.querySelector('#quick-action-copy-address');
  //   const addToCompareOption = item.querySelector('#quick-action-add-to-compare');
  //
  //   if (quickActionsEl && quickActionsEl.classList.contains("active")) {
  //     if (copyAddressOption) {
  //       copyAddressOption.removeEventListener('click', copyAddress);
  //     }
  //     if (addToCompareOption) {
  //       addToCompareOption.removeEventListener('click', addToCompareOptionClick)
  //     }
  //   } else {
  //     if (copyAddressOption) {
  //       copyAddressOption.addEventListener('click', copyAddress);
  //     }
  //     if (addToCompareOption) {
  //       addToCompareOption.addEventListener('click', addToCompareOptionClick)
  //     }
  //   }
  // };

  const botoes = document.querySelectorAll("#open-quick-actions");

  botoes.forEach((botao) => {
    botao.addEventListener("click", toggleEl);
  });
};

export const toggleFilters = () => {
  const button = document.querySelector("#community-filters-btn");
  if (button) {
    button.addEventListener("click", (e) => {
      document.dispatchEvent(new CustomEvent("openFilters", {
        bubbles: true,
        detail: e.currentTarget,
      }));
    });
  }

  document.addEventListener('communitiesRendered', (e) => {
    if (e.detail) {
      currentFiltersBody = e.detail;
    }
    destroyCommunityMap();
  });
};


const openQuickViewModal = (e) => {
  e.preventDefault();
  const { id, dniid } = e.currentTarget.dataset;
  if (id) {
    initQuickViewModal(id, dniid);
  }
};

export const handleQuickViewModal = () => {
  const openQuickViewModalButton = document.querySelectorAll(
    ".open-quick-view-modal"
  );

  openQuickViewModalButton.forEach(quickView => {
    quickView.addEventListener("click", openQuickViewModal);
  });
};


/*
export const initQuickViewModal = (id = '') => {
  console.log('');
  getQuickViewDataById(id)
    .then(quickViewData => {
      newPropertyContainer = document.createElement('div');
      newPropertyContainer.classList.add('property-container');
      let availableApartments = '';
      if (quickViewData.quickView && Array.isArray(quickViewData.quickView.AvailableApartments)) {
        quickViewData.quickView.AvailableApartments.forEach(aprt => {
          availableApartments += `<span>${getUnitType(aprt)}</span>`;
        })
      }
      let amenities = '';
      if (quickViewData.quickView && Array.isArray(quickViewData.quickView.Amenities)) {
        quickViewData.quickView.Amenities.forEach(amenity => {
          amenities += `
            <li>
              <i class="amenities-icon ${amenity.Icon}" aria-hidden="true"></i>
              <span>${amenity.Name}</span>
            </li>
          `;
        });
      }

      let imageFilters = '';
      let allImages = [];
      let imagesArray = [];
      if (quickViewData.quickView && quickViewData.quickView.Images) {
        imagesArray = Object.entries(quickViewData.quickView.Images);
        for (const [imgKey, images] of imagesArray) {
          allImages.push(...images);
          imageFilters +=
            `<button class="filter" data-category="${imgKey}">
              <span>${imgKey} (${images.length})</span>
              <img src="${images[0]}" alt="${imgKey}">
            </button>`;
        }
        imageFilters =
          `<button class="filter active" data-category="All">
            <span>All (${allImages.length})</span>
            <img src="${allImages[0]}" alt="all">
          </button>` + imageFilters;
      }

      let imageSliders = '';
      allImages.forEach((img, i) => {
        imageSliders += `
          <div class="swiper-slide">
            <img src="${img}" data-index="${i}" />
          </div>
        `;
      })

      newPropertyContainer.innerHTML = `
        <div class="image-gallery-buttons">
          <svg class="arrow-back"><use xlink:href="#arrow-back"></use></svg>
          <div class="image-gallery-view-btn">
            <svg class="grid-view"><use xlink:href="#grid-view"></use></svg>
            <svg class="list-view"><use xlink:href="#list-view"></use></svg>
          </div>
        </div>
        <div class="property-details">
          ${quickViewData.quickView && quickViewData.quickView.Name ? `<h1>${quickViewData.quickView.Name}</h1>` : ''}
          ${quickViewData.quickView && quickViewData.quickView.Address ? `<p class="address">${quickViewData.quickView.Address}</p>` : ''}
          ${availableApartments ? `
            <p class="property-types">
              ${availableApartments}
            </p>
          ` : ''}
          ${quickViewData.quickView && quickViewData.quickView.Description ? `
            <p class="description">${quickViewData.quickView.Description}</p>
          ` : ''}
          ${amenities ? `
            <ul class="amenities">
              ${amenities}
            </ul>
          ` : ''}

          ${quickViewData.quickView && quickViewData.quickView.PageUrl && quickViewData.labels && quickViewData.labels.ViewCommunity ? `
            <a href="${quickViewData.quickView.PageUrl}" class="view-community">
              ${quickViewData.labels.ViewCommunity}
            </a>
          ` : ''}
          ${quickViewData.quickView && quickViewData.quickView.PhoneNumber ? `
            <p class="call">
              <svg><use xlink:href="#phone"></use></svg>
              <a href="tel:+375292203444">
                ${quickViewData.labels.CallUs}: ${quickViewData.quickView.PhoneNumber}
              </a>
            </p>
          ` : ''}

          <div class="actions">
            <a class="action-item apt-fav save${!isMobile ? ' rounded': ''}${quickViewData.quickView.IsSaved ? ' saved': ''}" href="#save" data-id="${id}">
              <svg class="saved-items"><use xlink:href="#saved-items"></use></svg>
               ${quickViewData.labels && quickViewData.labels.Favorite ? `
              <span>${quickViewData.labels.Favorite}</span>
            `: ''}
            </a>
            <a class="action-item schedule${!isMobile ? ' rounded': ''}">
              <svg class="schedule-item"><use xlink:href="#calendar"></use></svg>
              ${quickViewData.labels && quickViewData.labels.ScheduleATour ? `
              <span>${quickViewData.labels.ScheduleATour}</span>
            `: ''}
            </a>
            <a class="action-item compare${!isMobile ? ' rounded': ''}${quickViewData.quickView.IsCompare ? ' compared': ''}" data-id="${id}">
              <svg class="plus-item"><use xlink:href="#plus-thin"></use></svg>
              ${quickViewData.labels && quickViewData.labels.Compare ? `
             <span>${quickViewData.labels.Compare}</span>
            ` : ''}
            </a>
            ${isMobile ? `
              <a class="action-item mobile-call" href="tel:${quickViewData.quickView.PhoneNumber}">
                <svg><use xlink:href="#phone"></use></svg>
                <span>
                  ${quickViewData.labels.CallUs}
                </span>
              </a>
            ` : ''}
          </div>
        </div>
        <div class="media-container${imagesArray.length === 0 && !isMobile ? ' expanded-map' : ''}">
          ${imagesArray.length !== 0 ?
            `
            <div class="image-wrapper">
              <div class="filters">
                ${imageFilters}
              </div>
              <div class="swiper swiper-custom">
                <div class="swiper-wrapper">
                  ${imageSliders}
                </div>
                <div class="swiper-pagination swiper-pagination-custom"></div>
                ${!isMobile ? `
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                ` : ''}

              </div>
              <div class="image-gallery">
              </div>
            </div>
            ` : ''
          }
          <div class="map-wrapper">
            <div class="expand-map">
              <div id="expand-collapse-map">
                ${imagesArray.length !== 0 || isMobile ? `
                  <span id="expand-map">${quickViewData.labels.ExpandMap}</span>
                  <span id="collapse-map">${quickViewData.labels.CollapseMap}</span>
                  <svg><use xlink:href="#arrow-left"></use></svg>
                ` : ''}
              </div>
            </p>

          </div>
          <div id="quick-view-map">

          </div>
        </div>
        </div>
      `;
      newPropertyContainer.querySelector('.apt-fav.save').addEventListener('click', (e) => {
        handleSaveEvent(e);
      });
      const swiper = newPropertyContainer.querySelector('.swiper');
      if (swiper) {
        swiper.addEventListener('click', attachImageGalleryClick);
      }
      newPropertyContainer.querySelector('.action-item.compare').addEventListener('click', (e) => {
        e.stopPropagation();
        addToCompareHandler(e, allImages[0], quickViewData.quickView && quickViewData.quickView.Name);
      });
      newPropertyContainer.querySelector('#expand-collapse-map').addEventListener('click', (e) => {
        e.stopPropagation();
        newPropertyContainer.querySelector('.media-container').classList.toggle('expanded-map');
      });
      newPropertyContainer.querySelector('.arrow-back').addEventListener('click', arrowBackHandler);
      newPropertyContainer.querySelector('.image-gallery-view-btn').addEventListener('click', (e) => {
        e.stopPropagation();
        newPropertyContainer.querySelector('.image-gallery').classList.toggle('grid-view');
        newPropertyContainer.querySelector('.image-gallery-view-btn').classList.toggle('grid-view');
      });
      const imageGalleryContainerEl = newPropertyContainer.querySelector('.image-gallery');
      allImages.forEach((img, i) => {
        const imgEl = document.createElement('img');
        imgEl.setAttribute('src', img);
        imgEl.setAttribute('data-index', i);
        imageGalleryContainerEl.appendChild(imgEl);
        imgEl.addEventListener('click', imageGalleryElClick);

      })
      openModalGlobal(newPropertyContainer);
      initQuickViewMap(newPropertyContainer, quickViewData);
      imageSlider(newPropertyContainer, quickViewData);
    })
    .catch(console.error);
}

const arrowBackHandler = (e) => {
  e.stopPropagation();
  if (newPropertyContainer.classList.contains('image-gallery-full-screen')) {
    newPropertyContainer.classList.remove('image-gallery-full-screen');
    fullScreenSwiperEl.remove();
    counterEl.remove();
    if (fullScreenSwiper) {
      fullScreenSwiper.destroy();
    }
  } else {
    newPropertyContainer.classList.remove('image-gallery-opened');
    newPropertyContainer.querySelector('.image-gallery-view-btn').classList.remove('grid-view');
    newPropertyContainer.querySelector('.image-gallery').classList.remove('grid-view');
  }
}

const initQuickViewMap = async (el, data) => {
  const { Map } = await google.maps.importLibrary("maps");
  const lat = data && data.quickView && data.quickView.Coordinates && data.quickView.Coordinates.Lat || 40.6839597;
  const lng = data && data.quickView && data.quickView.Coordinates && data.quickView.Coordinates.Lon || -74.2163569;
  const mapOptions = {
    center: { lat, lng },
    zoom: 15,
    disableDefaultUI: true,
    zoomControl: true,
    styles: googleMapStyles,
  };
  const map = new Map(el.querySelector("#quick-view-map"), mapOptions);
  const marker = new google.maps.Marker({
    position: { lat, lng },
    map: map,
    icon: {
      url: '/assets/img/maa-icon.svg',
      scaledSize: new google.maps.Size(pinsize, pinsize)
    },
  });
}

export const imageGalleryElClick = (e) => {
  e.stopPropagation();
  if (newPropertyContainer) {
    const target = e.currentTarget;
    const targetIndex = target.getAttribute('data-index');
    newPropertyContainer.classList.add('image-gallery-full-screen');
    fullScreenSwiperEl = document.createElement('div');
    fullScreenSwiperEl.classList.add('full-screen-swiper');

    counterEl = document.createElement('span');
    counterEl.classList.add('swiper-full-screen-counter')
    const images = [...newPropertyContainer.querySelector('.image-gallery').children];
    counterEl.innerHTML = `${+targetIndex + 1} / ${images.length}`;
    newPropertyContainer.appendChild(counterEl);
    newPropertyContainer.appendChild(fullScreenSwiperEl);
    let imageSliders = '';
    images.forEach(img => {
      const imgSrc = img.getAttribute('src');
      const dataIndex  = img.getAttribute('data-index');
      imageSliders += `
        <div class="swiper-slide">
          <img src="${imgSrc}" data-index="${dataIndex}" />
        </div>
      `;
    });
    fullScreenSwiperEl.innerHTML = `
      <div class="swiper-wrapper">
        ${imageSliders}
      </div>
    `;
    const swiperOptions = {
      loop: true,
      spaceBetween: 50,
      initialSlide: +targetIndex,
      on: {
        slideChange: (e) => {
          counterEl.innerHTML = `${e.realIndex + 1} / ${images.length}`;
        }
      }
    };
    fullScreenSwiper = new Swiper('.full-screen-swiper', swiperOptions);
  }
}

export const attachImageGalleryClick = (e) => {
  e.stopPropagation();
  if (newPropertyContainer && isMobile) {
    const target = e.currentTarget;
    newPropertyContainer.classList.add('image-gallery-opened');
    const activeSlide = target.querySelector('.swiper-slide-active');
    const index = activeSlide.dataset.swiperSlideIndex;
    const imageGallery = newPropertyContainer.querySelector('.image-gallery');
    if (index && index !== '0' && imageGallery) {
      const imageToScroll = imageGallery.querySelector(`[data-index="${index}"]`);
      if (imageToScroll) {
        imageToScroll.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}

const imageSlider = (el, data) => {
  const swiperOptions = {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
    spaceBetween: 50,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };
  let swiper = new Swiper('.swiper', swiperOptions);

  const filters = el.querySelectorAll(".filter");
  const swiperWrapper = el.querySelector(".swiper-wrapper");

  filters.forEach((filter) => {
    filter.addEventListener("click", function (e) {
      const { category } = e.currentTarget.dataset;
      filters.forEach((otherFilter) => {
        if (otherFilter !== filter) {
          otherFilter.classList.remove("active");
        } else {
          otherFilter.classList.add("active");
        }
      });
      const slides = newPropertyContainer.querySelectorAll(".swiper-slide");
      const imageGallery = newPropertyContainer.querySelector('.image-gallery');
      slides.forEach(slide => slide.remove());
      if (imageGallery && imageGallery.children) {
        [...imageGallery.children].forEach((img) => img.remove());
      }
      let imagesToRender = [];
      if (category !== 'All') {
        imagesToRender = data.quickView.Images[category];
      } else if (category === 'All') {
        Object.values(data.quickView.Images).forEach(val => {
          imagesToRender.push(...val);
        })
      }
      imagesToRender.forEach((image, i) => {
        const imgEl = document.createElement('div');
        imgEl.classList.add('swiper-slide');
        const imgSrcEl = document.createElement('img');
        imgSrcEl.setAttribute('src', image);
        imgSrcEl.setAttribute('data-index', i);
        imgEl.appendChild(imgSrcEl);
        swiperWrapper.appendChild(imgEl);
        const imgGalleryEl = imgSrcEl.cloneNode(true);
        imgGalleryEl.addEventListener('click', imageGalleryElClick);
        imageGallery.appendChild(imgGalleryEl);
      })
      swiper.destroy();
      swiper = new Swiper('.swiper', swiperOptions);
    });
  });
};
*/



// WEBPACK FOOTER //
// ./src/templates/components/maa-communities/maa-communities.js